import axios from "axios";
import { validateClinicBranchParams } from "@/utils/routeValidation";

const modulePatientGroup = {
  namespaced: true,
  state: {
    groupList: [],
  },
  mutations: {
    setGroupList(state, data) {
      state.groupList = Array.isArray(data) ? data : [];
    },
  },
  getters: {
    getGroupList: state => state.groupList,
  },
  actions: {
    fetchGroupList({ commit }, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "fetchGroupList")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .get(`/api/patient-group/${payload.clinicUrl}/${payload.branchUrl}`)
        .then(res => {
          commit("setGroupList", res.data);
          return res;
        });
    },

    createGroup(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "createGroup")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .post(`/api/patient-group/${payload.clinicUrl}/${payload.branchUrl}`, payload.data)
        .then(res => res.data);
    },

    updateGroup(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "updateGroup")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .put(`/api/patient-group/${payload.clinicUrl}/${payload.branchUrl}/${payload.groupId}`, payload.data)
        .then(res => res.data);
    },

    deleteGroup(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "deleteGroup")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .delete(`/api/patient-group/${payload.clinicUrl}/${payload.branchUrl}/${payload.groupId}`)
        .then(res => res.data);
    },

    addMembers(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "addMembers")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .post(
          `/api/patient-group/${payload.clinicUrl}/${payload.branchUrl}/${payload.groupId}/members`,
          { patientIds: payload.patientIds }
        )
        .then(res => res.data);
    },

    removeMembers(_, payload) {
      if (!validateClinicBranchParams(payload.clinicUrl, payload.branchUrl, "removeMembers")) {
        return Promise.reject(new Error("Invalid clinic/branch parameters"));
      }

      return axios
        .delete(
          `/api/patient-group/${payload.clinicUrl}/${payload.branchUrl}/${payload.groupId}/members`,
          { data: { patientIds: payload.patientIds } }
        )
        .then(res => res.data);
    },
  },
};

export default modulePatientGroup;
